import { useState } from "react";
import { Mail, Send } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function NewsletterCard() {
  const [email, setEmail] = useState("");
  const [freq, setFreq] = useState("daily");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, frequency: freq });
      toast.success(data.message || "Subscribed!");
      setEmail("");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="bg-slate-900 text-white rounded-xl p-6 md:p-10 grid md:grid-cols-2 gap-6 items-center" data-testid="newsletter-card">
      <div>
        <div className="inline-flex items-center gap-2 text-orange-400 text-xs font-bold uppercase tracking-wider mb-2">
          <Mail className="w-4 h-4"/> Daily Job Alerts
        </div>
        <h3 className="text-2xl md:text-3xl font-extrabold leading-tight" style={{fontFamily:"'Cabinet Grotesk',sans-serif"}}>Never miss a govt job notification again.</h3>
        <p className="text-slate-300 mt-2 text-sm">Get fresh vacancies, admit cards, and results — straight to your inbox.</p>
      </div>
      <form onSubmit={submit} className="space-y-3" data-testid="newsletter-form" aria-label="Newsletter subscription">
        <label htmlFor="newsletter-email-input" className="sr-only">Email address</label>
        <Input id="newsletter-email-input" data-testid="newsletter-email" required type="email" placeholder="your@email.com" value={email} onChange={(e)=>setEmail(e.target.value)} aria-label="Email address" className="h-12 bg-white text-slate-900"/>
        <div className="flex gap-2 text-sm" role="group" aria-label="Digest frequency">
          {["daily","weekly"].map((f)=>(
            <button type="button" key={f} data-testid={`freq-${f}`} aria-pressed={freq===f} onClick={()=>setFreq(f)} className={`px-4 py-2 rounded-md font-semibold uppercase tracking-wider text-xs transition-colors ${freq===f?'bg-orange-600 text-white':'bg-slate-800 text-slate-300 hover:bg-slate-700'}`}>{f}</button>
          ))}
        </div>
        <Button data-testid="newsletter-submit" type="submit" disabled={loading} className="w-full h-12 bg-orange-600 hover:bg-orange-700 text-white font-semibold">
          <Send className="w-4 h-4 mr-2"/>{loading?"Subscribing...":"Subscribe Free"}
        </Button>
      </form>
    </div>
  );
}
